// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueSocketIO from 'vue-socket.io'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import VueOnlinePlugin from 'vue-navigator-online'
import VueQrcodeReader from 'vue-qrcode-reader'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import store from './store'
import config from './config'
import filters from './filters'
import theme from './config/theme'
import SocketInstance from './config/socket'

import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false

Vue.component(VueQrcode.name, VueQrcode)
Vue.use(Vuetify, { theme })
Vue.use(VeeValidate)
Vue.use(VueOnlinePlugin)
Vue.use(VueSocketIO, SocketInstance)
Vue.use(VueQrcodeReader)

config.load()
filters.load()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js